import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { ClientProfileViewModel } from '@common/model/client/profile/clientProfileViewModel';
import { NotFilled } from './notFilled';

export interface ClientLocationProps {
  clientProfile: ClientProfileViewModel;
}

export const ClientLocation: React.FC<ClientLocationProps> = ({ clientProfile }) => {
  const cityName = clientProfile.city?.translation.name?.trim();
  const address = clientProfile.address?.trim();

  if (!cityName && !address) {
    return (
      <Typography variant="body">
        <NotFilled>Укажите город и адрес</NotFilled>
      </Typography>
    );
  }

  if (cityName && !address) {
    return <Typography variant="body">{cityName}</Typography>;
  }

  if (!cityName && address) {
    return <Typography variant="body">{address}</Typography>;
  }

  const cityLower = cityName?.toLowerCase() ?? '';
  const addressLower = address?.toLowerCase() ?? '';
  const location = cityName && address ? (addressLower.includes(cityLower) ? address : `${cityName}, ${address}`) : address || cityName;

  return (
    <Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }} variant="body">
      {location}
    </Typography>
  );
};
